import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ErrorOutline } from "@mui/icons-material";

import { useAudienceUtils } from "@/hooks";
import { Audience } from "@/types";

interface UnshareAudienceDialogProps {
  audience: Audience;
  open: boolean;
  onClose: () => void;
}

const UnshareAudienceDialog: React.FC<UnshareAudienceDialogProps> = ({
  audience,
  open,
  onClose,
}) => {

  const { utils, action } = useAudienceUtils(audience.audience_id, audience);

  return (
    <Dialog open={open} disableEnforceFocus aria-labelledby="delete-dialog">
      <DialogTitle>
        <Typography>Remove Shared Audience</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>
          Please confirm you wish to remove <b>{audience.audience_name}</b> as a shared audience.
          In order to see the audience again, the audience must be re-shared with you.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => utils.handleDeleteShare(`/${audience.audience_type === 'build' ? 'audience' : audience.audience_type}`)}
          loading={action.status === 'loading'}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnshareAudienceDialog;
